/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Col_MinInputs */

const vi_warehouse_sales_col_min = /** @type {(inputs: Warehouse_Sales_Col_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn tối thiểu`)
};

/**

* @param {Warehouse_Sales_Col_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_col_min = /** @type {((inputs?: Warehouse_Sales_Col_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Col_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_col_min(inputs)
});